import '../style/visitDetails.css';
import React, { useState } from "react";
import t from "../services/i18n/i18n";

const VisitDetails = ({ data, onClose, onAccept, onReject }: {
    data: {
        RequestId: { label: string };
        OrganizationName: { label: string };
        OrganizationUnit: { label: string };
        VisitDate: { label: string };
        Status: { label: string };
        VisitPurpose: { label: string };
        VisitorName: { label: string };
        VisitorCompany: { label: string };
        Question1: { label: string };
        Question2: { label: string };
        Question3: { label: string };
        Question4: { label: string };
        Question5: { label: string };
        Question6: { label: string };
        Question7: { label: string };
        Question8: { label: string };
        Question9: { label: string };
        Question10: { label: string };
        Attendant: { label: string };
        WhoChanged: { label: string };
        ChangeDate: { label: string };
        ResidenceCountry: { label: string };
        VisitedCountries: { label: string };
        VisitedRegions: { label: string };
        Question8Visible: boolean;
        Question9Visible: boolean;
        VisitedRegionsVisible: boolean;
    };
    onClose: () => void;
    onAccept: (reason: string) => void;
    onReject: (reason: string) => void;
}) => {
    const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
    const [isAcceptDialogOpen, setIsAcceptDialogOpen] = useState(false); // Новое состояние
    const [rejectReason, setRejectReason] = useState("");
    const [acceptReason, setAcceptReason] = useState(""); // Для причины accept

    const openAcceptDialog = () => {
        setIsAcceptDialogOpen(true);
    };

    const closeAcceptDialog = () => {
        setIsAcceptDialogOpen(false);
        setAcceptReason(""); // Очищаем причину подтверждения
    };

    const handleAcceptConfirm = () => {
        onAccept(acceptReason.trim()); // Передаем причину подтверждения
        setIsAcceptDialogOpen(false); // Закрываем диалог
        onClose(); // Закрываем основную форму
    };

    const openRejectDialog = () => {
        setIsRejectDialogOpen(true);
    };

    const closeRejectDialog = () => {
        setIsRejectDialogOpen(false);
        setRejectReason(""); // Очищаем причину отклонения
    };

    const handleRejectConfirm = () => {
        if (rejectReason.trim()) {
            onReject(rejectReason.trim());
            setIsRejectDialogOpen(false);
            onClose();
        }
    };

    const isAcceptReasonValid = () => {
        // Проверяем, есть ли хотя бы один вопрос с ответом "yes"
        const hasYesAnswer = Object.keys(data).some((key) => {
            // @ts-ignore
            return key.startsWith("Question") && data[key]?.label === "yes";
        });

        // Если есть "yes", причина не может быть пустой
        if (hasYesAnswer) {
            console.log("hasYesAnswer: " + hasYesAnswer);
            return acceptReason.trim().length > 0;
        }

        // Если "yes" нет,  причина может быть пустой
        return true;
    };


    return (
        <div className="issue-form-container">
            <div className="issue-form-header">
                <h2>{t('form.title')} {data.RequestId.label}</h2>
                <button className="close-button" onClick={onClose}> &#9587; </button>
            </div>

            <div className="issue-form-body">
                <div className="form-column">
                    <p><strong>{t('form.requestId')}:</strong> {data.RequestId.label}</p>
                    <p><strong>{t('form.orgName')}:</strong> {data.OrganizationName.label}</p>
                    <p><strong>{t('form.orgUnit')}:</strong> {data.OrganizationUnit.label}</p>
                    <p><strong>{t('form.visitPurpose')}:</strong> {data.VisitPurpose.label}</p>
                    <p><strong>{t('form.visitorName')}:</strong> {data.VisitorName.label}</p>
                    <p><strong>{t('form.visitorCompany')}:</strong> {data.VisitorCompany.label}</p>
                    <p><strong>{t('form.visitDate')}:</strong> {data.VisitDate.label}</p>
                    <p><strong>{t('form.status')}:</strong> {t('tabs.list.status.' + data.Status.label)}</p>
                    <p><strong>{t('form.attendant')}:</strong> {data.Attendant.label}</p>
                    <p><strong>{t('form.whoChanged')}:</strong> {data.WhoChanged.label}</p>
                    <p><strong>{t('form.changeDate')}:</strong> {data.ChangeDate.label}</p>
                    <p><strong>{t('form.residenceCountry')}:</strong> {data.ResidenceCountry.label}</p>
                    <p><strong>{t('form.visitedCountries')}:</strong> {data.VisitedCountries.label}</p>
                    {data.VisitedRegionsVisible ? (
                        <p><strong>{t('form.visitedRegions')}:</strong> {data.VisitedRegions.label}</p>
                    ) : ('')}
                </div>
                <div className="form-column">
                    <p>
                        <strong>{t('form.question1')}:</strong>{" "}
                        {data.Question1.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question1.label)}</span>
                        ) : (
                            t('form.' + data.Question1.label)
                        )}
                    </p>
                    <p>
                        <strong>{t('form.question2')}:</strong>{" "}
                        {data.Question2.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question2.label)}</span>
                        ) : (
                            t('form.' + data.Question2.label)
                        )}
                    </p>
                    <p>
                        <strong>{t('form.question3')}:</strong>{" "}
                        {data.Question3.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question3.label)}</span>
                        ) : (
                            t('form.' + data.Question3.label)
                        )}
                    </p>
                    <p>
                        <strong>{t('form.question4')}:</strong>{" "}
                        {data.Question4.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question4.label)}</span>
                        ) : (
                            t('form.' + data.Question4.label)
                        )}
                    </p>
                    <p>
                        <strong>{t('form.question5')}:</strong>{" "}
                        {data.Question5.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question5.label)}</span>
                        ) : (
                            t('form.' + data.Question5.label)
                        )}
                    </p>
                    <p>
                        <strong>{t('form.question6')}:</strong>{" "}
                        {data.Question6.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question6.label)}</span>
                        ) : (
                            t('form.' + data.Question6.label)
                        )}
                    </p>
                    <p>
                        <strong>{t('form.question7')}:</strong>{" "}
                        {data.Question7.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question7.label)}</span>
                        ) : (
                            t('form.' + data.Question7.label)
                        )}
                    </p>
                    {data.Question8Visible ? (
                        <p>
                            <strong>{t('form.question8')}:</strong>{" "}
                            {data.Question8.label === "yes" ? (
                                <span className="yes-badge">{t('form.' + data.Question8.label)}</span>
                            ) : (
                                t('form.' + data.Question8.label)
                            )}
                        </p>
                    ) : ('')}
                    {data.Question9Visible ? (
                        <p>
                            <strong>{t('form.question9')}:</strong>{" "}
                            {data.Question9.label === "yes" ? (
                                <span className="yes-badge">{t('form.' + data.Question9.label)}</span>
                            ) : (
                                t('form.' + data.Question9.label)
                            )}
                        </p>
                    ) : ('')}
                    <p>
                        <strong>{t('form.question10')}:</strong>{" "}
                        {data.Question10.label === "yes" ? (
                            <span className="yes-badge">{t('form.' + data.Question10.label)}</span>
                        ) : (
                            t('form.' + data.Question10.label)
                        )}
                    </p>
                </div>
            </div>

            <div className="form-footer">
                <button className="reject-button" onClick={openRejectDialog}>{t('form.button.reject')}</button>
                <button className="accept-button" onClick={openAcceptDialog}>{t('form.button.resolve')}</button>
            </div>

            {/* Диалог для Reject */}
            {isRejectDialogOpen && (
                <div className="dialog-overlay">
                    <div className="dialog-container">
                        <h3>{t('form.rejectReasonTitle')}</h3>
                        <textarea
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            className="reason-input"
                        />
                        <div className="dialog-footer">
                            <button
                                onClick={handleRejectConfirm}
                                className="reject-button"
                                disabled={!rejectReason.trim()}
                            >
                                {t('form.button.reject')}
                            </button>
                            <button onClick={closeRejectDialog} className="cancel-button" style={{marginLeft: 20}}>
                                {t('form.button.cancel')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Диалог для Accept */}
            {isAcceptDialogOpen && (
                <div className="dialog-overlay">
                    <div className="dialog-container">
                        <h3>{t('form.acceptReasonTitle')}</h3>
                        <p>{t('form.acceptReasonSubTitle')}</p>
                        <textarea
                            value={acceptReason}
                            onChange={(e) => setAcceptReason(e.target.value)}
                            className="reason-input"
                        />
                        <div className="dialog-footer">
                            <button
                                onClick={handleAcceptConfirm}
                                className={`accept-button ${!isAcceptReasonValid() ? 'disabled' : ''}`}
                                disabled={!isAcceptReasonValid()}
                            >
                                {t('form.button.resolve')}
                            </button>
                            <button onClick={closeAcceptDialog} className="cancel-button" style={{marginLeft: 20}}>
                                {t('form.button.cancel')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VisitDetails;

